/**
 * Helper: SVG map
 * -----------------------------------------------------------------------------
 * Store for SVG icon paths to use in render functions.
 * - Use SVGOMG to compress files.
 * - Remove any inline fill colours.
 * - Add closing tags to suppress warnings on HTML5 compatibility.
 * - Add correct BEM class names.
 */
const minus = `
  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon__minus" viewBox="0 0 36 36">
    <path d="M10 16h16v4H10z"></path>
  </svg>
`;

const plus = `
  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon__plus" viewBox="0 0 36 36">
    <path d="M16 10v6h-6v4h6v6h4v-6h6v-4h-6v-6h-4z"></path>
  </svg>
`;

export const misc = {
  minus,
  plus,
};
